import { theme } from '../../theme/theme'
import { IconProps } from './types'

const DEFAULT_SIZE = 24
const DEFAULT_COLOR = theme.color.black

export const Calendar = ({ size = DEFAULT_SIZE, color = DEFAULT_COLOR }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.6667 4.6665H3.33333C2.59695 4.6665 2 5.26346 2 5.99984V20.6665C2 21.4029 2.59695 21.9998 3.33333 21.9998H20.6667C21.403 21.9998 22 21.4029 22 20.6665V5.99984C22 5.26346 21.403 4.6665 20.6667 4.6665Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M2 10H22" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7.3335 6.66667V2" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M16.6665 6.66667V2" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M6.33333 13.3335C6.26741 13.3335 6.20296 13.353 6.14814 13.3897C6.09333 13.4263 6.0506 13.4784 6.02537 13.5393C6.00014 13.6002 5.99354 13.6672 6.00641 13.7319C6.01927 13.7965 6.05101 13.8559 6.09763 13.9025C6.14425 13.9491 6.20364 13.9809 6.2683 13.9938C6.33296 14.0066 6.39999 14 6.46089 13.9748C6.5218 13.9496 6.57386 13.9068 6.61049 13.852C6.64712 13.7972 6.66667 13.7328 6.66667 13.6668C6.66667 13.5784 6.63155 13.4936 6.56904 13.4311C6.50652 13.3686 6.42174 13.3335 6.33333 13.3335Z"
      fill={color}
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.33333 18C6.26741 18 6.20296 18.0195 6.14814 18.0562C6.09333 18.0928 6.0506 18.1449 6.02537 18.2058C6.00014 18.2667 5.99354 18.3337 6.00641 18.3984C6.01927 18.463 6.05101 18.5224 6.09763 18.569C6.14425 18.6157 6.20364 18.6474 6.2683 18.6603C6.33296 18.6731 6.39999 18.6665 6.46089 18.6413C6.5218 18.6161 6.57386 18.5733 6.61049 18.5185C6.64712 18.4637 6.66667 18.3993 6.66667 18.3333C6.66667 18.2449 6.63155 18.1601 6.56904 18.0976C6.50652 18.0351 6.42174 18 6.33333 18Z"
      fill={color}
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.9998 13.3335C11.9339 13.3335 11.8695 13.353 11.8146 13.3897C11.7598 13.4263 11.7171 13.4784 11.6919 13.5393C11.6666 13.6002 11.66 13.6672 11.6729 13.7319C11.6858 13.7965 11.7175 13.8559 11.7641 13.9025C11.8108 13.9491 11.8701 13.9809 11.9348 13.9938C11.9995 14.0066 12.0665 14 12.1274 13.9748C12.1883 13.9496 12.2404 13.9068 12.277 13.852C12.3136 13.7972 12.3332 13.7328 12.3332 13.6668C12.3332 13.5784 12.2981 13.4936 12.2355 13.4311C12.173 13.3686 12.0882 13.3335 11.9998 13.3335Z"
      fill={color}
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.9998 18C11.9339 18 11.8695 18.0195 11.8146 18.0562C11.7598 18.0928 11.7171 18.1449 11.6919 18.2058C11.6666 18.2667 11.66 18.3337 11.6729 18.3984C11.6858 18.463 11.7175 18.5224 11.7641 18.569C11.8108 18.6157 11.8701 18.6474 11.9348 18.6603C11.9995 18.6731 12.0665 18.6665 12.1274 18.6413C12.1883 18.6161 12.2404 18.5733 12.277 18.5185C12.3136 18.4637 12.3332 18.3993 12.3332 18.3333C12.3332 18.2449 12.2981 18.1601 12.2355 18.0976C12.173 18.0351 12.0882 18 11.9998 18Z"
      fill={color}
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.6668 13.3335C17.6009 13.3335 17.5365 13.353 17.4816 13.3897C17.4268 13.4263 17.3841 13.4784 17.3589 13.5393C17.3336 13.6002 17.327 13.6672 17.3399 13.7319C17.3528 13.7965 17.3845 13.8559 17.4311 13.9025C17.4777 13.9491 17.5371 13.9809 17.6018 13.9938C17.6665 14.0066 17.7335 14 17.7944 13.9748C17.8553 13.9496 17.9074 13.9068 17.944 13.852C17.9806 13.7972 18.0002 13.7328 18.0002 13.6668C18.0002 13.5784 17.965 13.4936 17.9025 13.4311C17.84 13.3686 17.7552 13.3335 17.6668 13.3335Z"
      fill={color}
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.6668 18C17.6009 18 17.5365 18.0195 17.4816 18.0562C17.4268 18.0928 17.3841 18.1449 17.3589 18.2058C17.3336 18.2667 17.327 18.3337 17.3399 18.3984C17.3528 18.463 17.3845 18.5224 17.4311 18.569C17.4777 18.6157 17.5371 18.6474 17.6018 18.6603C17.6665 18.6731 17.7335 18.6665 17.7944 18.6413C17.8553 18.6161 17.9074 18.5733 17.944 18.5185C17.9806 18.4637 18.0002 18.3993 18.0002 18.3333C18.0002 18.2449 17.965 18.1601 17.9025 18.0976C17.84 18.0351 17.7552 18 17.6668 18Z"
      fill={color}
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
